module.exports = __webpack_public_path__ + "static/img/Bachelor_010519.3a8705f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010519.jpg
// module id = 176
// module chunks = 0